export class Location {
	description: string
	street: string
	houseNumber: string
	postalCode: string
	city: string
	suburb: string
	country: string
	lon: number
	lat: number
}


// WEBPACK FOOTER //
// ./src/app/models/location.model.ts